// extracted by mini-css-extract-plugin
export default {"root":"Wallet_root__CvUjX","item":"Wallet_item__ItvkE","note":"Wallet_note__AlP4F"};